import(/* webpackMode: "eager" */ "D:\\orion-nextjs\\orion-nextjs\\src\\app\\Inspect-Nau-App\\page.js");
